/** Motion dice: can this screen show the 3D tray? (WebGL, and motion not reduced.) Checked once. */
let webgl: boolean | null = null;

export function canShow3d(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  if (webgl === null) {
    try {
      const c = document.createElement('canvas');
      webgl = !!(c.getContext('webgl2') ?? c.getContext('webgl'));
    } catch {
      webgl = false;
    }
  }
  return webgl;
}

/** The 3D tray failed to load (or lost its context): classic dice for the rest of this visit. */
export function give3dUp(): void {
  webgl = false;
}
